import { render, staticRenderFns } from "./MhlvCaseDetailsDrawer.vue?vue&type=template&id=2b6e8b52"
import script from "./MhlvCaseDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./MhlvCaseDetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports